module.exports = __webpack_public_path__ + "static/media/italyLong.e97e688a.jpg";